// extracted by mini-css-extract-plugin
export default {"formGroups":"ModifyEntryModal_formGroups__ntLq+","input":"ModifyEntryModal_input__ALN8j","label":"ModifyEntryModal_label__g5OJ+","charsOption":"ModifyEntryModal_charsOption__RQD7B"};